import { InputProps } from '../interfaces'

export default function useInputText(props: InputProps): any {
  const { id, name } = props
  const elemId = id ? id : `id_${name}`
  return elemId
}
